<template>
    <div>
        <b-row>
            <b-col md="6">
                <CCard>
                    <CCardHeader color="primario" text-color="white">
                        <i class="fas fa-chart-bar"></i> <span class="h5"> Estadísticas</span>
                    </CCardHeader>
                    <CCardBody>
                        <span class="h6 text-muted">ESTADÍSTICAS DEL SISTEMA PARA LOS ALIMENTOS:
                        </span>
                        <hr>
                        <b-row class="justify-content-center text-center">
                            <b-col cols="12" class=" my-2 icon-custom">
                                <i style="inline-size: auto" class="ico fas fa-check-double fa-3x pb-1"></i>
                                <br>
                                <span class="lg-numero">{{listAlimentos.length}}</span>
                                <br>
                                <span class="text-muted">Alimentos Registrados</span>
                            </b-col>
                        </b-row>
                    </CCardBody>
                </CCard>
            </b-col>
            <b-col md="6">
                <CCard>
                    <CCardHeader color="primario" text-color="white">
                        <i class="fas fa-cog"></i><span class="h5"> Alimentos</span>
                    </CCardHeader>
                    <CCardBody>
                        <b-row class="justify-content-center text-center">
                            <b-col cols="6" class="my-2">
                                <b-button block variant="custom" @click="modalRegAlimentos = true">
                                    <i style="inline-size: auto" class="fas fa-plus-circle fa-3x pb-1"></i><br><span>Nuevo Alimento</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </CCardBody>
                </CCard>
            </b-col>
            <b-col md="12">
                <CCard>
                    <CCardHeader color="primario" text-color="white">
                        <i class="fas fa-list fa-md"></i><span class="h5"> Listado Alimentos Registrados </span>
                        <b-button v-if="listAlimentos.length >= 1" class="float-right" variant="success" size="sm" @click="exportDataToExcel">
                        <i class="fas fa-download mr-1"></i>
                        Exportar</b-button>
                    </CCardHeader>
                    <CCardBody>
                        <b-row>
                            <b-col md="3">
                                <b-form-group label="Registros por página" class="text-muted">
                                    <b-form-select size="xl" v-model="porPagina" :options="paginaOpciones"></b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                            </b-col>
                            <b-col md="3">
                                <b-form-group label="Busqueda:" class="text-muted">
                                    <b-input-group size="xl">
                                        <b-input-group-prepend is-text>
                                            <i class="fas fa-search my-0 mx-0"></i>
                                        </b-input-group-prepend>
                                        <b-form-input type="search" v-model="filter" id="filterInput" placeholder="Buscar..."></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col md="12">
                                <b-table bordered hover show-empty mediun responsive outlined :items="listAlimentos" :fields="camposAlimentos" :current-page="paginaActual" :per-page="porPagina" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" empty-text="Aún no hay datos en esta sección." empty-filtered-text="No hay datos que coincidan con tu busqueda.">
                                    <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                                    <template v-slot:cell(nombreGuiaPrincipal)="data">
                                        <template v-if="listUsuarios.find(x => x.idGuia == data.item.idGuia) == null">
                                            {{''}}
                                        </template>
                                        <template v-else>
                                            {{listUsuarios.find(x => x.idGuia == data.item.idGuia).nombre | truncate(50)}}
                                        </template>
                                        <!-- {{listUsuarios.find(x => x.idGuia == data.item.idGuia).nombre | truncate(50)}} -->
                                    </template>
                                    <template v-slot:cell(nombreAlimento)="data">
                                        {{data.item.nombreAliment}}
                                    </template>
                                    <template v-slot:cell(detalleAlimento)="data">
                                        {{data.item.detalleAliment | truncate(20)}}
                                    </template>
                                    <template v-slot:cell(fecha)="data">
                                        <!-- {{data.item.fecha}} -->
                                        {{formatearFecha(data.item.fecha,'DD-MM-YYYY')}}
                                    </template>
                                    <template v-slot:cell(observacion)="data">
                                        {{data.item.observacion | truncate(20)}}
                                    </template>
                                    <template v-slot:cell(opciones)="param">
                                        <b-button size="sm" v-c-tooltip.hover.click="'Ver detalles'" @click="abrirModalActAlimentos(param)" variant="dark" class=" mr-1 mb-1">
                                            <span class="btn-inner--icon">
                                                <i class="fas fa-search my-0 mx-0"></i>
                                            </span>
                                        </b-button>

                                        <b-button size="sm" class="mr-1 mb-1" v-c-tooltip.hover.click="'Eliminar'" @click="eliminarAlimentos(param)" variant="danger">
                                            <span class="btn-inner--icon">
                                                <i class="fas fa-trash-alt  my-0 mx-0"></i>
                                            </span>
                                        </b-button>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </CCardBody>
                    <CCardFooter>
                        <b-pagination size="sm" v-model="paginaActual" :total-rows="filasTotales" :per-page="porPagina" first-number last-number align="right" class="my-0"></b-pagination>
                    </CCardfooter>
                </CCard>
            </b-col>
        </b-row>

        <CModal :show.sync="modalRegAlimentos" size="xl" color="primario" :closeOnBackdrop="false">
            <template #header>
                <h6 class="modal-title">
                    <i class="fas fa-plus-square fa-md"></i>
                    <span class="h5"> Nuevo Registro de Alimentos</span>
                </h6>
                <CButtonClose @click="modalRegAlimentos = false" class="text-white" />
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(registrarAlimentos)">
                    <b-row>
                        <b-col md="12">
                            <validation-provider name="guia principal" rules="required" v-slot="{errors}">
                                <b-form-group label="Guia Principal:" class="mb-2">
                                    <!-- <v-select :reduce="listDocumentos => listDocumentos.idDocumento" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosGuia.idTipoDocumento , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosGuia.idTipoDocumento" :options="listDocumentos"> -->
                                    <v-select :reduce="listUsuarios => listUsuarios.idGuia" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosRegAlimentos.idGuia , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosRegAlimentos.idGuia" :options="listUsuarios" @search:blur="blurAlimentos">
                                        <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                    </v-select>
                                    <div class="invalid-feedback">{{ errors[0]}}</div>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="6">
                            <validation-provider name="nombre de alimento" :rules="{required: true}" v-slot="validationContext">
                                <b-form-group label="Nombre del Alimento:" class="mb-2">
                                    <b-form-input  :state="getValidationState(validationContext)" placeholder="Ingrese el Nombre del Alimento" v-model.trim="datosRegAlimentos.nombreAliment"></b-form-input>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="6">
                            <validation-provider name="fecha" :rules="{required: true}" v-slot="validationContext">
                                <b-form-group label="Fecha:" class="mb-2">
                                    <b-form-input type="date" :state="getValidationState(validationContext)" v-model="datosRegAlimentos.fecha"></b-form-input>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="12">
                            <validation-provider name="detalle de alimento" :rules="{required: true}" v-slot="validationContext">
                                <b-form-group label="Detalle del Alimento:" class="mb-2">
                                    <b-form-textarea v-model="datosRegAlimentos.detalleAliment" :state="getValidationState(validationContext)" placeholder="Ingrese el Detalle del Alimento" rows="3" max-rows="6"></b-form-textarea>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="12">
                            <validation-provider name="observación" :rules="{required: false}" v-slot="validationContext">
                                <b-form-group label="Observación(Opcional):" class="mb-2">
                                    <b-form-textarea v-model="datosRegAlimentos.observacion" :state="getValidationState(validationContext)" placeholder="Ingrese la Observación" rows="3" max-rows="6"></b-form-textarea>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="12" class="text-right my-2">
                            <b-button :disabled="disabled" variant="success" class=" mr-2" type="submit">
                                Guardar
                            </b-button>
                            <b-button variant="danger" @click="modalRegAlimentos = false">
                                Cancelar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </CModal>

        <CModal :show.sync="modalActAlimentos" size="xl" color="primario" :closeOnBackdrop="false">
            <template #header>
                <h6 class="modal-title"> <i class="fas fa-edit fa-md"></i>
                    <span class="h5"> Actualizar Alimento</span></h6>
                <CButtonClose @click="modalActAlimentos = false" class="text-white" />
            </template>
            <validation-observer ref="observer1" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(actualizarAlimentos)">
                    <b-row>
                        <b-col md="12">
                            <validation-provider name="guia principal" rules="required" v-slot="{errors}">
                                <b-form-group label="Guia Principal:" class="mb-2">
                                    <!-- <v-select :reduce="listDocumentos => listDocumentos.idDocumento" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosGuia.idTipoDocumento , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosGuia.idTipoDocumento" :options="listDocumentos"> -->
                                    <v-select :reduce="listUsuarios => listUsuarios.idGuia" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosActAlimentos.idGuia , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosActAlimentos.idGuia" :options="listUsuarios" @search:blur="blurActualizarAlimentos">
                                        <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                    </v-select>
                                    <div class="invalid-feedback">{{ errors[0]}}</div>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="6">
                            <validation-provider name="nombre de alimento" :rules="{required: true}" v-slot="validationContext">
                                <b-form-group label="Nombre del Alimento:" class="mb-2">
                                    <b-form-input  :state="getValidationState(validationContext)" placeholder="Ingrese el Nombre del Alimento" v-model.trim="datosActAlimentos.nombreAliment"></b-form-input>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="6">
                            <validation-provider name="fecha" :rules="{required: true}" v-slot="validationContext">
                                <b-form-group label="Fecha:" class="mb-2">
                                    <b-form-input type="date" :state="getValidationState(validationContext)" v-model="datosActAlimentos.fecha"></b-form-input>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="12">
                            <validation-provider name="detalle de alimento" :rules="{required: true}" v-slot="validationContext">
                                <b-form-group label="Detalle del Alimento:" class="mb-2">
                                    <b-form-textarea v-model="datosActAlimentos.detalleAliment" :state="getValidationState(validationContext)" placeholder="Ingrese el Detalle del Alimento" rows="3" max-rows="6"></b-form-textarea>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                         <b-col md="12">
                            <validation-provider name="observación" :rules="{required: false}" v-slot="validationContext">
                                <b-form-group label="Observación:" class="mb-2">
                                    <b-form-textarea v-model="datosActAlimentos.observacion" :state="getValidationState(validationContext)" placeholder="Ingrese la Observación" rows="3" max-rows="6"></b-form-textarea>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="12" class="text-right my-2">
                            <b-button :disabled="disabled" variant="success" class=" mr-2" type="submit">
                                Actualizar
                            </b-button>
                            <b-button variant="danger" @click="modalActAlimentos = false">
                                Cancelar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </CModal>
    </div>
</template>

<script>
import firebase from 'firebase';
const dbAlimentos = firebase.firestore().collection('alimentos');
const dbUsuario = firebase.firestore().collection('users');
import XLSX from 'sheetjs-style-v2';

export default {
    data(){
        return {
            listAlimentos: [],
            listUsuarios: [],
            disabled: false,

            filasTotales: 1,
            paginaActual: 1,
            porPagina: 10,
            paginaOpciones: [10, 25, 50, 100, {
                value: 9999999,
                text: "Mostrar todos"
            }],
            filter: null,
            filterOn: [],

            camposAlimentos: [
                {
                    key: "index",
                    label: "N°",
                    class: "text-center",
                },
                {
                    key: "nombreGuiaPrincipal",
                    label: "Guia Principal",
                    class: "text-center",
                },
                {
                    key: "nombreAlimento",
                    label: "Nombre del Alimento",
                    class: "text-center",
                },
                {
                    key: "detalleAlimento",
                    label: "Detalle Del Alimento",
                    class: "text-center",
                },
                {
                    key: "fecha",
                    label: "Fecha",
                    class: "text-center",
                },
                {
                    key: "observacion",
                    label: "Observación",
                    class: "text-center",
                },
                {
                    key: "opciones",
                    label: "",
                    class: "text-center",
                },
            ],

            datosRegAlimentos: {
                idGuia: '',
                nombreAliment: '',
                fecha: moment().format('YYYY-MM-DD'),
                detalleAliment: '',
                observacion: ''
            },

            datosActAlimentos: {
                id: '',
                idGuia: '',
                nombreAliment: '',
                fecha: '',
                detalleAliment: '',
                observacion: ''
            },

            modalRegAlimentos: false,
            modalActAlimentos: false,
        }
    },
    methods: {
        exportDataToExcel() {
            let now = moment().format('YYYYMMDDHHmm');

            const valUpper = text => {
                if (text != null && text !== undefined) {
                    return text.toString().toUpperCase();
                }
                return '';
            };

            const valDate = date => {
                if (date && date !== undefined) {
                    return moment(date).format('DD-MM-YYYY')
                }
                return '';
            };

            let dataExcel = this.listAlimentos.map(data => {
                return {
                    A: valUpper(this.listUsuarios && this.listUsuarios !== undefined ?
                        this.listUsuarios.filter(x => x.idGuia == data.idGuia).length > 0 ?
                        this.listUsuarios.filter(x => x.idGuia == data.idGuia)[0].nombre : '' : ''),
                    B: valUpper(data['nombreAliment']),
                    C: valDate(data['fecha']),
                    D: valUpper(data['detalleAliment']),
                    E: valUpper(data['observacion']),
                };
            });

            let dataWS = XLSX.utils.json_to_sheet(dataExcel, {
                origin: 'A4',
            });

            let dataWSMerges = [{
                s: {
                    r: 1,
                    c: 1,
                },
                e: {
                    r: 1,
                    c: 3,
                },
            }];

            dataWS['!merges'] = dataWSMerges;

            let dataWSCols = [
                {
                    wch: 30, //A
                },
                {
                    wch: 30, //B
                },
                {
                    wch: 15, //C
                },
                {
                    wch: 100, //D
                },
                {
                    wch: 100, //E
                },
            ];

            dataWS['!cols'] = dataWSCols;

            for(let i of [
                {
                    f: 'B2',
                    v: 'ALIMENTOS',
                },
                {
                    f: 'C2',
                },
                {
                    f: 'D2',
                },
                {
                    f: 'A4',
                    v: 'NOMBRE DE GUÍA',
                },
                {
                    f: 'B4',
                    v: 'NOMBRE DEL ALIMENTO',
                },
                {
                    f: 'C4',
                    v: 'FECHA',
                },
                {
                    f: 'D4',
                    v: 'DETALLE DEL ALIMENTO',
                },
                {
                    f: 'E4',
                    v: 'OBSERVACIÓN',
                },
            ]){
                XLSX.utils.sheet_add_aoa(dataWS, [
                    [i.v || '']
                ], {
                    origin: i.f,
                });

                dataWS[i.f].s = {
                    numFmt: i.w || 'general',
                    fill: {
                        fgColor: {
                            rgb: i.b ? 'FFFFFF' : 'F2F2F2',
                        },
                    },
                    font: {
                        name: 'arial',
                        sz: 8,
                        bold: i.b ? false : true,
                        color: {
                            rgb: i.b ? '000000' : '1F497D',
                        },
                    },
                    border: {
                        top: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                        bottom: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                        right: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                        left: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                    },
                    alignment: {
                        horizontal: 'center',
                        vertical: 'center',
                        wrapText: 1,
                    },
                };
            }

            for (let k in dataExcel) {
                for (let i of Object.keys(dataExcel[0])) {
                    dataWS[`${i}${(parseInt(k) + 5).toString()}`].s = {
                        numFmt: '@',
                        fill: {
                            fgColor: {
                                rgb: 'FFFFFF',
                            },
                        },
                        font: {
                            name: 'arial',
                            sz: 8,
                            color: {
                                rgb: '000000',
                            },
                        },
                        border: {
                            top: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                            bottom: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                            right: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                            left: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                        },
                        alignment: {
                            horizontal: 'center',
                            vertical: 'center',
                        },
                    };
                }
            }

            let wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS, 'ALIMENTOS');
            XLSX.writeFile(wb, `ALIMENTOS ${now}.xlsx`);
        },
        onFiltered(itemsFiltrados) {
            this.filasTotales = itemsFiltrados.length
            this.paginaActual = 1
        },
        getValidationState({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        formatearFecha(fecha,formato){
            return moment(fecha).format(formato);
        },
        blurAlimentos() {
            this.computedForms.refs['guia principal'].validate();
        },
        blurActualizarAlimentos() {
            this.computedFormActualizar.refs['guia principal'].validate();
        },
        listarUsuarios() {
            let me = this;

            dbUsuario
            .where("estado" , "==" , 2)
            .where("idCliente", "==", String(me.$store.state.user.idCliente))
            .where("rol","==","guia")
            .onSnapshot((querySnapshot) => {
                me.listUsuarios = [];
                querySnapshot.forEach((doc) => {
                    me.listUsuarios.push({
                        idGuia: doc.id,
                        nombre: doc.data().nombre + ' ' + doc.data().apellidoPaterno + ' ' + doc.data().apellidoMaterno,
                    });
                });
            });
        },
        registrarAlimentos() {
            let me = this;

            me.disabled = true;
            dbAlimentos.add({
                idGuia: me.datosRegAlimentos.idGuia.trim(),
                nombreAliment: me.datosRegAlimentos.nombreAliment.trim(),
                fecha: me.datosRegAlimentos.fecha.trim(),
                detalleAliment: me.datosRegAlimentos.detalleAliment.trim(),
                observacion: me.datosRegAlimentos.observacion.trim(),
                fechaCreacion: firebase.firestore.Timestamp.fromDate(new Date()),
                fechaModificacion: '',
                fechaEliminar: '',
                idCliente: me.$store.state.user.idCliente.trim(),
                estado: 2,
            }).then((doc) =>{
                me.swat('success', 'Registrado satisfactoriamente')
                me.modalRegAlimentos = false;
                me.disabled = false;
            }).catch((error) => {
                me.disabled = false;
                me.swat('error', 'Algo salió mal!');
            });
        },
        listarAlimentos() {
            let me = this;
            dbAlimentos
            .where("estado","==",2)
            .where("idCliente", "==", String(me.$store.state.user.idCliente))
            .onSnapshot((querySnapshot)=>{
                me.listAlimentos = [];
                querySnapshot.forEach((doc)=> {
                    me.listAlimentos.push({
                        id: doc.id,
                        nombreAliment: doc.data().nombreAliment,
                        idGuia: doc.data().idGuia,
                        detalleAliment: doc.data().detalleAliment,
                        observacion: doc.data().observacion,
                        fecha: doc.data().fecha,
                        fechaCreacion: doc.data().fechaCreacion,
                    });
                });

                me.listAlimentos.sort((a, b) => (a.fechaCreacion > b.fechaCreacion) ? -1 : ((b.fechaCreacion > a.fechaCreacion) ? 1 : 0));
            });
        },
        actualizarAlimentos() {
            let me = this;

            me.disabled = true;

            dbAlimentos.doc(me.datosActAlimentos.id).update({
                idGuia: me.datosActAlimentos.idGuia.trim(),
                nombreAliment: me.datosActAlimentos.nombreAliment.trim(),
                detalleAliment: me.datosActAlimentos.detalleAliment.trim(),
                observacion: me.datosActAlimentos.observacion.trim(),
                fecha: me.datosActAlimentos.fecha.trim(),
                fechaModificacion: firebase.firestore.Timestamp.fromDate(new Date()),
            }).then((doc)=> {
                me.swat('success', 'Modificado satisfactoriamente')
                me.modalActAlimentos = false
                me.disabled = false;
            }).catch((error) => {
                me.disabled = false;
                me.swat('error', 'Algo salió mal!')
            });
        },
        eliminarAlimentos(param) {
            let me = this;
            me.$swal.fire({
                title: '¿Estas seguro de eliminar el Alimento?',
                text: "¡No podrás revertir esto!",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
            }).then((result) => {
                if (result.isConfirmed) {
                    dbAlimentos.doc(param.item.id).update({
                        estado: 1,
                        fechaEliminar: firebase.firestore.Timestamp.fromDate(new Date()),
                    })
                    .then(() => {
                        me.swat('success', 'Eliminado satisfactoriamente')
                        me.disabled = false;
                    })
                    .catch((error) => {
                        me.disabled = false;
                        me.swat('error', 'Algo salió mal!')
                    });
                }
            });
        },
        abrirModalActAlimentos(param) {
            let me = this;

            me.datosActAlimentos.id = param.item.id;
            me.datosActAlimentos.idGuia = param.item.idGuia.trim();
            me.datosActAlimentos.nombreAliment = param.item.nombreAliment.trim();
            me.datosActAlimentos.fecha = param.item.fecha.trim();
            me.datosActAlimentos.detalleAliment = param.item.detalleAliment.trim();
            me.datosActAlimentos.observacion = param.item.observacion.trim();

            me.modalActAlimentos = true;
        },
        swat(icon, title) {
            this.$swal.mixin({
                toast: true,
                showConfirmButton: false,
                position: 'bottom-right',
                timer: 3500,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            }).fire({
                icon: icon,
                title: title
            });
        },
        resetModalRegistrarAlimentos() {
            this.$nextTick(() => {
                this.$refs.observer.reset();
            });

            this.datosRegAlimentos.idGuia = '';
            this.datosRegAlimentos.nombreAliment = '';
            this.datosRegAlimentos.fecha = moment().format('YYYY-MM-DD');
            this.datosRegAlimentos.detalleAliment = '';
            this.datosRegAlimentos.observacion = '';
        },
        resetModalActualizarAlimentos() {
            this.$nextTick(() => {
                this.$refs.observer1.reset();
            });

            this.datosActAlimentos.id = '';
            this.datosActAlimentos.idGuia = '';
            this.datosActAlimentos.nombreAliment = '';
            this.datosActAlimentos.fecha = moment().format('YYYY-MM-DD');
            this.datosActAlimentos.detalleAliment = '';
            this.datosActAlimentos.observacion = '';
        },
    },
    computed: {
        computedForms() {
            return this.$refs.observer;
        },
        computedFormActualizar() {
            return this.$refs.observer1;
        },
    },
    watch: {
        modalRegAlimentos: function (val) {
            if (val == false) {
                this.resetModalRegistrarAlimentos();
            }
        },
        modalActAlimentos: function (val) {
            if (val == false) {
                this.resetModalActualizarAlimentos();
            }
        },
    },
    mounted(){
        if (this.$store.state.user) {
            this.listarUsuarios();
            this.listarAlimentos();
        }
    }
}
</script>
